/**
 * @generated SignedSource<<3e8828cb7a78de156ab23e6eb1c46397>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CompanyProjectType = "FEEDBACK_HOUSE" | "LOGID" | "OPEN_PIX" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LoginForm_query$data = {
  readonly company: {
    readonly hasHRModule: boolean;
    readonly preferences: {
      readonly core: {
        readonly authConfigs: ReadonlyArray<{
          readonly active: boolean | null | undefined;
          readonly buttonLabel: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly integration: {
          readonly microsoft: {
            readonly tenant: string | null | undefined;
          };
        };
        readonly login: {
          readonly enableEmail: boolean | null | undefined;
          readonly enableEnrollment: boolean | null | undefined;
          readonly enableSaml: boolean | null | undefined;
          readonly enableSaml2: boolean | null | undefined;
          readonly enableTaxID: boolean | null | undefined;
        };
      };
    };
    readonly projectType: CompanyProjectType | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"LoginSamlField_company" | "LoginTextField_company">;
  } | null | undefined;
  readonly " $fragmentType": "LoginForm_query";
};
export type LoginForm_query$key = {
  readonly " $data"?: LoginForm_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoginForm_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LoginForm_query",
  "selections": [
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LoginTextField_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LoginSamlField_company"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasHRModule",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyCorePreferences",
              "kind": "LinkedField",
              "name": "core",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthConfig",
                  "kind": "LinkedField",
                  "name": "authConfigs",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "buttonLabel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "active",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CompanyCoreLoginPreferences",
                  "kind": "LinkedField",
                  "name": "login",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enableSaml",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enableSaml2",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enableEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enableTaxID",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "enableEnrollment",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CompanyIntegrationPreferences",
                  "kind": "LinkedField",
                  "name": "integration",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CompanyIntegrationMicrosoftPreferences",
                      "kind": "LinkedField",
                      "name": "microsoft",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tenant",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c0508efb6e38c9b96d8c8bde820ebf3f";

export default node;
